<section class="flex flex-col gap-7">
	<div
		class="flex justify-between items-center border-b border-grey-veryLight pb-7"
	>
		<h3 class="text-xl">Complete Identity Verification With Treefort</h3>
		<div class="w-24">
			<app-powered-by-treefort></app-powered-by-treefort>
		</div>
	</div>

	<div class="flex flex-col gap-3 text-sm">
		<p>
			By clicking “Agree & Connect”, you agree to accept the
			<app-anchor
				[url]="treefortUrl"
				cssClasses="text-blue-500"
				class="inline cursor-pointer"
				[external]="true"
				>Treefort User Licensing Agreement.</app-anchor
			>
		</p>
		<p>By continuing, you acknowledge and agree that:</p>
		<ul class="flex flex-col gap-3 pl-3 ml-3 list-disc">
			<li>
				LawLabs and Treefort may collect, store, and process the information
				provided by you and your clients for the purpose of providing identity
				verification (IDV) services.
			</li>
			<li>
				Your clients will be directed to the Treefort website and will be
				required to accept Terms and Conditions prior to Treefort conducting the
				IDV service.
			</li>
			<li>
				Treefort charges a fee of $25.00 per
				<strong>completed IDV report</strong>, which will be billed to you by
				LawLabs alongside other Closer transactions.
			</li>
			<li>
				By default, any Treefort IDV fees incurred within a file will be
				automatically sent to the file’s Statement of Account for recovery. You
				can change this default behaviour within
				<app-anchor
					(onClick)="closeModal()"
					class="inline text-blue-500"
					[url]="idvSettingsUrl"
					>business settings</app-anchor
				>.
			</li>
		</ul>
	</div>
	<app-treefort-promotion-banner
		class="flex justify-center"
	></app-treefort-promotion-banner>
	<div class="flex justify-between items-end mt-6">
		<app-button (onClick)="closeButtonClick()" btn="border" size="small"
			>Not Now</app-button
		>
		<app-button (onClick)="startIDVClick()" btn="primary" size="small">{{
			primaryButtonText
		}}</app-button>
	</div>
</section>
